// extracted by mini-css-extract-plugin
export var childrenContainer = "_3m-0";
export var virtualScrollArea = "_3m-1";